// extracted by mini-css-extract-plugin
export default {"table":"AuthorizationCredentialSection_table__ZvKH1"};